import { useRouter } from 'next/router'
import classNames from 'classnames'
import { TCategoryStocks } from '../../types/TCategory'
import { stockCategories } from './helpers'
import SEOHeader from '@/components/Common/SEOHeader'
import StrapiV4WidgetSelector from '@/stories/strapi-4/widget-components/widget-selector'
import INListingWright from '@/components/Stocks/Pages/StockListingPageV1'
import INListing from '@/components/Stocks/Pages/StockListingPage'
import useFetchStrapiSourceData from '@/hooks/use-get-strapi-source-data'
import {
  TStrapiV4BreadcrumbWidget,
  TStrapiV4GreenStickyCta,
  TStrapiV4PageType,
} from '@/stories/strapi-4/common-types'
import SidebarNav from '@/components/MutualFunds/Listing/SidebarNav'
import { StrapiV4BreadcrumbWidget } from '@/stories/strapi-4/widget-components/breadcrumb-widget/breadcrumb-widget'
import { StrapiV4GreenStickyCTA } from '@/stories/strapi-4/widget-components/green-sticky-cta/green-sticky-cta'

const StrapiCategoryPage = props => {
  const { strapiApiData } = props
  const router = useRouter()
  const slugsArr = router.asPath.split('/')

  let sourceData = strapiApiData as TStrapiV4PageType

  const strapiClientData = useFetchStrapiSourceData(
    strapiApiData,
    slugsArr,
    false,
  )

  if (strapiClientData) {
    sourceData = strapiClientData
  }
  const breadcrumbs = sourceData.data.attributes.content.find(
    el => el.__component === 'widgets.breadcrumb-widget',
  ) as TStrapiV4BreadcrumbWidget | undefined

  const greenStickyCTA = sourceData.data.attributes.content.find(
    el => el.__component === 'widgets.green-sticky-cta',
  ) as TStrapiV4GreenStickyCta | undefined

  const showCategoryNavlinks = sourceData.data.attributes.content.some(
    item =>
      item.__component === 'widgets.static-widgets' &&
      item.static_widget_name === 'table-of-content',
  )
  const firstRichTextEditorIndex =
    sourceData?.data.attributes.content.findIndex(
      el => el.__component === 'widgets.rich-text-editor',
    )

  return (
    <div>
      {sourceData.data.attributes.seo && (
        <SEOHeader data={sourceData.data.attributes.seo} />
      )}
      {breadcrumbs && <StrapiV4BreadcrumbWidget {...breadcrumbs} />}

      <div
        className={classNames({
          'herolike-wrapper mb-10 flex flex-col-reverse gap-8 md:flex-row lg:pt-2.5':
            showCategoryNavlinks,
        })}
      >
        {showCategoryNavlinks && (
          <div className="no-scrollbar md:w-3/10 sticky top-20 w-full self-center overflow-y-auto bg-white md:top-24 md:h-[100vh] md:self-start 2xl:w-1/4">
            <SidebarNav linksData={stockCategories.data.search_nav[0]} />
          </div>
        )}
        <div
          className={classNames({
            'md:w-7/10 flex w-full flex-1 flex-col': showCategoryNavlinks,
          })}
        >
          {sourceData.data.attributes.content.map((el, idx) => {
            if (el.__component === 'widgets.dynamic-place-holder-v0') {
              switch (el.widget_type) {
                case 'INListing': {
                  return (
                    <INListing
                      {...props}
                      fromStrapi
                      showSidebar={!showCategoryNavlinks}
                    />
                  )
                }
                case 'INListingWright': {
                  return (
                    <INListingWright
                      listingData={el.data_source?.api as TCategoryStocks}
                      showSidebar={!showCategoryNavlinks}
                    />
                  )
                }
                default:
                  return (
                    <StrapiV4WidgetSelector
                      key={idx}
                      {...el}
                      notHero={showCategoryNavlinks}
                    />
                  )
              }
            } else if (
              el.__component === 'widgets.breadcrumb-widget' ||
              el.__component === 'widgets.green-sticky-cta'
            ) {
              return null
            }
            return (
              <StrapiV4WidgetSelector
                key={idx}
                {...el}
                notHero={showCategoryNavlinks}
                addClassNames={
                  el.addClassNames ??
                  (idx === firstRichTextEditorIndex && idx < 2 ? 'pb-0' : '')
                }
              />
            )
          })}
        </div>
      </div>
      <StrapiV4GreenStickyCTA
        text={greenStickyCTA?.text ?? 'Open Free Demat Account'}
      />
    </div>
  )
}

export default StrapiCategoryPage
